import React from 'react';
import styled from 'styled-components';

const Space = (props) => {
	return <StyledSpace {...props} />;
};

const StyledSpace = styled.div`
	height: ${(props) => props.height || '10px'};
`;

export default Space;
